import React from "react";
import {
  HeroBanner as DesignSystemHeroBanner,
  SectionHeader as DesignSystemSectionHeader,
} from "@relentless/rmds/v1/relentless.esm.js";

export function HeroBanner(props) {
  return <DesignSystemHeroBanner {...(props || {})} />;
}

export function SectionHeader(props) {
  const {
    variant = "h1",
    uppercase = false,
    showDivider = true,
    align = "left",
    className = "",
    ...rest
  } = props || {};
  return (
    <DesignSystemSectionHeader
      variant={variant}
      uppercase={uppercase}
      showDivider={showDivider}
      align={align}
      className={className}
      {...rest}
    />
  );
}

const SiteUI = { HeroBanner, SectionHeader };

export default SiteUI;
